import { ContactAccountantAccess } from '~/models';
export function getAccountantAccessItem(accountantAccess) {
    switch(accountantAccess){
        case ContactAccountantAccess.NonCandidate:
            return null;
        case ContactAccountantAccess.Active:
            return {
                id: 'remove',
                text: 'Remove Accountant Access',
                skin: 'error'
            };
        case ContactAccountantAccess.Invited:
            return {
                id: 'cancel',
                text: 'Cancel request',
                skin: 'error'
            };
        case ContactAccountantAccess.Candidate:
            return {
                id: 'request',
                text: 'Request Accountant Access'
            };
    }
}
